module.exports = __webpack_public_path__ + "img/module7.9d90a174.png";